export function createSketchStrategy (implementations) {
  return function (item) {
    const impl = implementations[item.type];
    if (impl) {
      return impl.apply(this, arguments);
    }
    throw new Error('Unknown sketch item type "' + item.type + '"');
  };
}
